import validator from 'validator';

export const isValidZipcode = (zipCode = '') => {
  return validator.isPostalCode(zipCode, 'FR');
};

export const isDromComZipcode = (zipCode = '') => {
  return (
    validator.isPostalCode(zipCode, 'FR') &&
    (!!zipCode?.startsWith('97') || !!zipCode?.startsWith('98'))
  );
};

export const isCorseZipcode = (zipCode = '') => {
  return (
    validator.isPostalCode(zipCode, 'FR') &&
    (!!zipCode?.startsWith('20') ||
      !!zipCode?.startsWith('2A') ||
      !!zipCode?.startsWith('2B'))
  );
};

export const isMetropolitanZipcode = (zipCode = '') => {
  return (
    validator.isPostalCode(zipCode, 'FR') &&
    !isDromComZipcode(zipCode) &&
    !isCorseZipcode(zipCode)
  );
};

export const isMetropolianAndMonacoZipcode = (zipCode = '') => {
  return isMetropolitanZipcode(zipCode) || !!zipCode?.startsWith('98');
};
